import { Link } from "../components/Link";
import { t } from "../i18n";
import { href } from "../lib/router";
import { useHeroData } from "../state/heroData";

export function NotFound() {
  const { hero } = useHeroData();
  return (
    <main className="container narrow center-screen">
      <h1>{t("app.notFound.title")}</h1>
      <p className="muted">{t("app.notFound.body")}</p>
      <Link to={href.hero()} className="btn btn--primary">
        {t("app.notFound.cta", { hero: hero.name })}
      </Link>
    </main>
  );
}
